import React, { useState } from 'react';
import HeaderContent from './HeaderContent';
import { Button, message } from 'antd';
import { withRouter } from 'react-router-dom';
import IssueCardFieldCustomizationInfo from '../../../../../components/skills/jira/IssueCardCustomization/IssueCardFieldCustomizationInfo';
import { updatePage } from '../ApphomeActions';
import IssueCard from '../../../jira/IssueCardCustomization/IssueCard';
import { getSkillUser } from '../../../../../components/skills/skills_action';
import { useSelector, useDispatch } from 'react-redux';
const IssuesContent = (props) => {
  const { apphome, hideCustomizeButtons, isPersonalApphome } = props;
  const dispatch = useDispatch();
  const [showCardCustomiztionModal, setShowCardCustomiztionModal] =
    useState(false);
  const skills = useSelector((state) => state.skills.skills);

  const page =
    apphome &&
    apphome.pages &&
    apphome.pages.find((page) => page._id === apphome.pageView);
  const apphomeCardCustomization =
    page && page.issueCardCustomizationInfo
      ? page.issueCardCustomizationInfo
      : null;
  const updateapphomeCustomizationInfo = async (cardCustomization) => {
    let data = {
      issueCardCustomizationInfo: cardCustomization,
    };

    await dispatch(
      updatePage(props.match.params.wId, apphome._id, apphome.pageView, data)
    );
    setShowCardCustomiztionModal(false);
  };

  const handleShowCardCustomizationModal = async () => {
    const jiraSkill = skills.find((skill) => skill.key === 'jira');
    const currentSkillUser = await dispatch(
      getSkillUser(props.match.params.wId, jiraSkill.skill_metadata._id)
    );
    if (!jiraSkill.skill_metadata.linked) {
      return message.error({
        content: (
          <>
            Jira is not connected. Click
            <a
              onClick={() => {
                props.history.push(
                  `/${props.match.params.wId}/skills/${jiraSkill.skill_metadata._id}/jira_software?view=connection`
                );
              }}
            >
              {' '}
              here{' '}
            </a>
            to connect to your Jira.
          </>
        ),
        onClick: () => message.destroy(),
      });
    }
    let isUserVerified = false;

    if (currentSkillUser && currentSkillUser.data.skillUser.token_obj) {
      isUserVerified = true;
    }
    if (!isUserVerified) {
      return message.error({
        content: (
          <>
            Verify your personal Jira connection. Click
            <a
              onClick={() => {
                props.history.push(
                  `/${props.match.params.wId}/skills/${jiraSkill.skill_metadata._id}/jira_software?view=personal_preferences`
                );
              }}
            >
              {' '}
              here{' '}
            </a>
            to verify.
          </>
        ),
      });
    }

    setShowCardCustomiztionModal(true);
  };
  return (
    <div>
      <HeaderContent
        title='My Issues'
        buttonName='Customize data'
        buttonType='issueList'
        hideCustomizeButtons={hideCustomizeButtons}
        isPersonalApphome={isPersonalApphome}
      />
      <div
        style={{
          paddingTop: '16px',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <div>
          {apphomeCardCustomization ? (
            <div style={{ maxHeight: '140px', overflowY: 'auto' }}>
              <IssueCard
                isApphomePreview={true}
                isApphome={true}
                {...apphomeCardCustomization}
                selectedAttributesDetailed={
                  apphomeCardCustomization.fieldsSelectedDetailed
                }
                selectedField={
                  apphomeCardCustomization &&
                  apphomeCardCustomization.fieldSelectedCompact
                }
              />
            </div>
          ) : (
            <>
              <div
                style={{ display: 'flex', gap: '8px', alignItems: 'center' }}
              >
                <a style={{ fontSize: '16px' }} to='#'>
                  P1-5
                </a>
                <div style={{ fontSize: '14px', color: '#E01E5A' }}>Open</div>
                <div style={{ fontSize: '16px' }}>Summary Text</div>
                <Button
                  className='apphome-display-btn'
                  style={{ marginLeft: '140px' }}
                >
                  View
                </Button>
              </div>
              <div
                style={{
                  display: 'flex',
                  gap: '8px',
                  alignItems: 'center',
                  paddingTop: '4px',
                }}
              >
                <a style={{ fontSize: '16px' }} to='#'>
                  P1-5
                </a>
                <div style={{ fontSize: '14px', color: '#E01E5A' }}>Open</div>
                <div style={{ fontSize: '16px' }}>Summary Text</div>
                <Button
                  className='apphome-display-btn'
                  style={{ marginLeft: '140px' }}
                >
                  View
                </Button>
              </div>
            </>
          )}
        </div>

        <div>
          <Button
            onClick={() => {
              handleShowCardCustomizationModal();
            }}
            className='apphome_primary_buttons'
            type='primary'
            disabled={hideCustomizeButtons}
          >
            Customize issuecard
          </Button>
          {showCardCustomiztionModal && (
            <IssueCardFieldCustomizationInfo
              close={() => {
                setShowCardCustomiztionModal(false);
              }}
              handleapphomeCardCustomization={updateapphomeCustomizationInfo}
              apphomeCardCustomization={apphomeCardCustomization}
              apphome={apphome}
              customizationIn='apphome'
              open={showCardCustomiztionModal}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default withRouter(IssuesContent);
